import React, { useEffect, useState } from "react";
import { BadgeCheck } from "lucide-react";
import { verifyEmailStatus } from "@/lib/api";
import { VerifyEmailDialog } from "@/components/VerifyEmailDialog";

export function EmailVerifyChip() {
  const [st, setSt] = useState(null);
  const [open, setOpen] = useState(false);
  const load = () => verifyEmailStatus().then(setSt).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!st) return null;
  if (st.email_verified) {
    return <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-emerald-700" data-testid="email-verified-chip"><BadgeCheck className="w-3.5 h-3.5" /> Verified</span>;
  }
  return (
    <>
      <button onClick={() => setOpen(true)} className="inline-flex items-center whitespace-nowrap rounded-full border border-amber-300 bg-amber-50 text-amber-800 hover:bg-amber-100 px-2.5 py-1 text-[11px] font-semibold min-h-[32px]" data-testid="profile-verify-email-btn">Email verify karein</button>
      <VerifyEmailDialog open={open} onOpenChange={setOpen} onVerified={load} />
    </>
  );
}
